import { useEffect } from "react";
import FillView from "../fillView/FillView";
import { useThemeContext } from "../theme/ThemeContext";
import { useMaintenanceModeContext } from "../../context/MaintenanceMode/MaintenanceModeContext";
import { useAuthContext } from "../auth/AuthContext";
import { Roles } from "../../constant/Roles";
import { useNavigate } from "react-router-dom";

interface AppContainerProps {
  children: React.ReactNode;
}

export const AppContainer = ({ children }: AppContainerProps) => {
  const { theme } = useThemeContext();

  return <FillView data-bs-theme={theme}>{children}</FillView>;
};
